import Popover from "@material-ui/core/Popover";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { ReactComponent as BlankLink } from "assets/icons/Group 240018.svg";
import { ReactComponent as Archive } from "assets/icons/archive.svg";
import { ReactComponent as Duplicate } from "assets/icons/duplicate2.svg";
import { ReactComponent as Star } from "assets/icons/star.svg";
import React from "react";
import { ReactComponent as DeleteSvgComponent } from "../assets/icons/delete-gray.svg";
import EditSvgComponent from "../assets/icons/svg/Edit/index";
import EyeSvgComponent from "../assets/icons/svg/EyeSvg/Eye";
import ActionSvgComponent from "../assets/icons/svg/actionSvg";

import "./style.scss";
import { fontConfig } from "theme/fontConfig";

export default function ClassPopOver({
  onViewClick,
  onEditClick,
  onDuplicateClick,
  onUpgradeClick,
  onArchiveClick,
  onActiveClick,
  onClassDeleteClick,
  onRegistrationLinkClick,
  onEditViewClick,
  action,
  style,
  sentInvitation,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <ActionSvgComponent
        height={style ? style.height : 14}
        width={style ? style.width : 14}
        onClick={handleClick}
        color={style && style.color}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          right: "300px",
          width: "182px",
        }}
      >
        <div
          className={`action-pop-over`}
          style={{
            width: "182px",
            fontFamily: fontConfig.ClassPopOverActionPopOverFont.family,
            fontSize: "14px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {sentInvitation ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                sentInvitation();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <BlankLink className="svg-size" />
              Send renewal form
            </div>
          ) : (
            ""
          )}
          {onRegistrationLinkClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onRegistrationLinkClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <BlankLink className="svg-size" /> Registration Link
            </div>
          ) : (
            ""
          )}
          {onViewClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onViewClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <EyeSvgComponent className="svg-size" /> View
            </div>
          ) : (
            ""
          )}
          {onEditClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onEditClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <EditSvgComponent className="svg-size" /> {"Edit"}
            </div>
          ) : (
            ""
          )}
          {onEditViewClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onEditViewClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <EditSvgComponent className="svg-size" /> {"View / Edit"}
            </div>
          ) : (
            ""
          )}
          {onDuplicateClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onDuplicateClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <Duplicate className="svg-size" /> {"Duplicate"}
            </div>
          ) : (
            ""
          )}
          {onUpgradeClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onUpgradeClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <Star className="svg-size" /> {"Upgrade Class"}
            </div>
          ) : (
            ""
          )}
          {onArchiveClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onArchiveClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <Archive className="svg-size" /> {"Archive"}
            </div>
          ) : (
            ""
          )}
          {onActiveClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onActiveClick();
                handleClose();
              }}
              style={{
                color: "#002E5C",
              }}
            >
              <KeyboardReturnIcon
                className="svg-size"
                style={{
                  fill: "#2555EF",
                }}
              />{" "}
              {"Move to Active"}
            </div>
          ) : (
            ""
          )}
          {onClassDeleteClick ? (
            <div
              className="delete-pop-over"
              onClick={() => {
                onClassDeleteClick();
                handleClose();
              }}
              style={{
                color: "#FF0A0A",
                paddingLeft: "10px",
              }}
            >
              <DeleteSvgComponent className="svg-size" />{" "}
              {action === "event" ? "Delete Event" : "Delete"}
            </div>
          ) : (
            ""
          )}
        </div>
      </Popover>
    </div>
  );
}
